<template>
  <TableLayout >
    
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import { fetcfindAllListhList, createCoffeeTask } from '@/api/business/taskRule'
export default {
  name: 'TaskRule',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      activityTime: [],
      // 搜索
      searchForm: {
        name: '',
        realName: '',
        activityStatus: '',
        starttime: '',
        endtime: '',
        type: 1 //类型0商家活动 1平台活动 2探店 3资讯
      },
      
     
    }
  },
  created () {
    this.getTaskRule()
  },
  methods: {
    getTaskRule() {
      fetcfindAllListhList()
        .then(res => {

        })
        .catch(e => {
          this.$tip.error(e)
        })
    },
    submit() {
      createCoffeeTask()
        .then(() => {
          this.$tip.success('设置成功')
        })
        .catch(e => {
          this.$tip.error(e)
        })
    }
  },
}
</script>
